import { TranslateModule } from '@ngx-translate/core'
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatetimePipe } from './datetime.pipe';

@NgModule({
	declarations: [DatetimePipe],
	imports: [
		CommonModule,
		TranslateModule
	],
	exports: [DatetimePipe],
})
export class DatetimeModule {}
